<template>
  <div class="login">
    <div class="login_logo">
      <img class="login_logo_img" src="@/assets/images/login/heizi.png" />
    </div>
    <div class="login_main">
      <div class="main_left">
        <el-carousel height="470px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="(item, index) in imglist" :key="index">
            <img class="main_img" :src="item" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="main_right">
        <div class="login-form">
          <div class="form-title">账号登陆</div>

          <div class="form-item">
            <i class="icon user"></i>
            <el-input v-model="loginForm.userName" placeholder="请输入账号" />
          </div>

          <div class="form-item">
            <i class="icon lock"></i>
            <el-input v-model="loginForm.passWord" placeholder="请输入密码" type="password" show-password />
          </div>

          <div class="form-item captcha">
            <i class="icon code"></i>
            <el-input v-model="loginForm.captcha" placeholder="请输入验证码" />
            <img class="captcha-img" :src="captchaImgUrl" @click="refreshCaptcha" />
          </div>

          <button class="login-btn" @click="loginSubmit()">登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import img1 from '@/assets/images/login/haibao4.png'
import img2 from '@/assets/images/login/haibao6.png'
import img3 from '@/assets/images/login/haibao3.png'
import { reactive, ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
// import { useUserStore } from '@/store/user'; // Pinia store
import { SYSTEM_NAME, URL } from '@/constant/Const';
import { login, getRouteList, getloginimage } from "@/api/auth/login/index";
import { refreshRoutes } from '@/router';

const router = useRouter();
// const userStore = useUserStore();

const systemName = SYSTEM_NAME;
const url = URL;

const loginForm = reactive({
  userName: '',
  passWord: '',
  captcha: '',
  uuid: '',
});
const imglist = ref([img1, img2, img3])
const loading = ref(false);
const isWindows = ref(true);
const mainRightWidth = ref('23vw');
const mainInputWidth = ref('15vw');
const captchaImgUrl = ref('');

const loginRef = ref(null);

onMounted(() => {
  refreshCaptcha();
  checkUserAgent();
});

function checkUserAgent() {
  const userAgent = navigator.userAgent;
  if (userAgent.includes('Windows') || userAgent.includes('Win')) {
    isWindows.value = true;
  } else {
    isWindows.value = false;
    mainRightWidth.value = '70vw';
    mainInputWidth.value = '53vw';
  }
}

function refreshCaptcha() {
  loginForm.uuid = uuidCompact();
  captchaImgUrl.value = url + `/api/login/captcha?uuid=${loginForm.uuid}&t=${Date.now()}`;
}

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

function uuidCompact() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function loginSubmit() {
  if (!loginForm.userName || !loginForm.passWord) {
    ElMessage.error('请输入用户名和密码');
    return;
  }
  loading.value = true;
  login(loginForm).then(resp => {
    console.log(resp);

    if (resp.data) {
      sessionStorage.setItem("token", resp.data.token);
      sessionStorage.setItem("userInfo", JSON.stringify(resp.data));
      getRouteList().then(result => {
        if (result.data && result.data.length > 0) {
          sessionStorage.setItem("menuList", JSON.stringify(result.data));
          // userStore.setMenuList(result.data);
          refreshRoutes();
          router.replace('/dashboard');
        } else {
          ElMessage.error('无路由数据，请联系管理员并重新登录！');
          sessionStorage.clear();
        }
        loading.value = false;
      }).catch(() => { loading.value = false; });
    } else {
      loading.value = false;
    }
  }).catch(() => { loading.value = false; });
}
</script>

<style lang="scss" scoped>
/* Login 样式 */
.login::v-deep {
  position: relative;
  width: 100vw;
  min-height: 100vh;

  background: #0064C8 url('@/assets/images/login/beijing.png') no-repeat center;
  background-size: cover;

  display: flex;
  flex-direction: column;
  align-items: center;

  /* logo 区 */
  .login_logo {
    margin-top: clamp(40px, 8vh, 90px);
    margin-bottom: clamp(40px, 6vh, 92px);
    display: flex;
    justify-content: center;

    .login_logo_img {
      width: 150px;
      height: auto;
    }
  }

  /* 主体卡片 */
  .login_main {
    width: 90%;
    max-width: 866px;
    min-height: 520px;
    padding: 20px;

    background: #ffffff;
    border-radius: 12px;

    box-sizing: border-box;
    display: flex;

    .main_left {
      width: 40%;
      height: 100%;

      .el-carousel {
        width: 100%;

      }

      .main_img {
        width: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .main_right {
      flex: 1;
      box-sizing: border-box;
      padding: clamp(20px, 3vw, 40px);

      .login-form {
        width: 100%;
        max-width: 360px;
        margin: 0 auto;

        display: flex;
        flex-direction: column;
        align-items: stretch;

        .form-title {
          text-align: center;
          font-size: 22px;
          font-weight: 600;
          color: #333;
          margin-bottom: 30px;
          position: relative;

          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: #e5e5e5;
            margin: 12px auto 0;
          }
        }

        .form-item {
          display: flex;
          align-items: center;
          height: 44px;
          border: 1px solid #e5e8ef;
          border-radius: 4px;
          padding: 0 12px;
          margin-bottom: 16px;
          box-sizing: border-box;

          .el-input {
            flex: 1;
            border: none;
            outline: none;
            font-size: 14px;
            color: #333;

            &::placeholder {
              color: #b0b4bd;
            }

            .el-input__wrapper {
              box-shadow: none !important;
            }
          }

          .icon {
            width: 18px;
            height: 18px;
            margin-right: 8px;
            background-size: contain;
            background-repeat: no-repeat;

            &.user {
              background-image: url('@/assets/images/login/shuruzhanghao.png');
            }

            &.lock {
              background-image: url('@/assets/images/login/shurumima.png');
            }

            &.code {
              background-image: url('@/assets/images/login/shuruyanzhengma.png');
            }
          }
        }

        .captcha {

          .captcha-img {
            width: 90px;
            height: 32px;
            background: #e5e5e5;
            border-radius: 4px;
          }
        }

        .login-btn {
          margin-top: 20px;
          height: 44px;
          background: #3a7afe;
          border: none;
          border-radius: 4px;
          color: #fff;
          font-size: 16px;
          cursor: pointer;

          &:hover {
            background: #2f6fe4;
          }
        }
      }

    }
  }

}

@media screen and (max-width: 992px) {
  .login {
    .login_main {
      .main_left {
        display: none;
      }

      .main_right {
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .login_main {
    padding: 16px;
    border-radius: 8px;
  }
}
</style>
